export const ONGOING_TRANSACTION = '0'
export const TRANSACTION_COMPLETED = '1'
export const EXECUTE_PAYMENT = '2'
export const ONGOING_SETTLEMENT = '3'
export const WAITING_RECEIVER = '4'
export const WAITING_SENDER = '5'
export const HAS_TO_PAY_RECEIVER = '6'
export const HAS_TO_PAY_SENDER = '7'
export const TIMEOUT_SENDER = '8'
export const TIMEOUT_RECEIVER = '9'
export const ONGOING_DISPUTE = '10'
export const APPEALABLE_LOOSER = '11'
export const APPEALABLE_WINNER = '12'
export const DISPUTE_RESOLVED = '13'
